import { forwardRef, ReactNode, useContext, useEffect } from 'react';
import {
  setupAttachmentPreviewListener,
  setupImagePreviewListener,
} from '../../../../config/handlers';
import { ChangeControlDTO } from '../../../../types/DocumentCreate';
import { EditorMode } from '../../../../util/EditModeUtils';
import { DocumentLayout } from '../../DocumentLayout/DocumentLayout';
import {
  DocumentOverviewContext,
  EditorStatus,
  EditorStatusContext,
} from '../Context';

type DocumentContentEditorProps = {
  changeControl: ChangeControlDTO;
  children: ReactNode;
  handleAttachmentClick: (attachmentId: string) => void;
};
export const ChangeControlSidebarWrapper = forwardRef<
  HTMLDivElement,
  DocumentContentEditorProps
>(({ changeControl, children, handleAttachmentClick }, ref) => {
  const { currentEditorMode, commentsPermission, qualioDocument } = useContext(
    DocumentOverviewContext,
  );

  const { ccEditorStatus } = useContext(EditorStatusContext);

  useEffect(() => {
    const contentElement = document.querySelector(
      '#changeControlEditorContent',
    );
    if (contentElement) {
      setupAttachmentPreviewListener(contentElement, handleAttachmentClick);
      setupImagePreviewListener(contentElement, handleAttachmentClick);
    }
  }, [handleAttachmentClick]);

  const isEditMode =
    currentEditorMode !== EditorMode.VIEW &&
    ccEditorStatus !== EditorStatus.CONNECTING;

  const shouldShowMultiRootEditor =
    qualioDocument.editor_version?.includes('multiroot');

  return (
    <DocumentLayout
      ref={ref}
      isEditMode={isEditMode}
      sections={changeControl.sections}
      sectionTitlesVisible={true}
      commentsPermission={commentsPermission}
      editorStatus={ccEditorStatus}
      editorName="changeControlEditorContent"
      contentId="changeControlEditorContent"
      commentControlId="changeControlCommentControl"
      sidebarId="changeControlSidebar"
      dataCy={{
        content: 'changeControlEditorContent',
        commentControl: 'changeControlCommentControl',
        commentButton: 'cc-comment-button',
        commentSidebar: 'changeControlSidebar',
      }}
      isLandscape={false}
      isMultiRootEditor={shouldShowMultiRootEditor}
    >
      {children}
    </DocumentLayout>
  );
});
